/**
 * Reusable Filter Row Component
 * Provides consistent filter input interface
 */

import React from 'react';
import { TextField, Button, Box } from '@mui/material';
import { useTranslate } from 'react-admin';

const FilterRow = ({
  value,
  filterValue,
  label,
  setValue,
  setFilterValue,
  placeholder = '',
  type = 'text',
  disabled = false,
  useBrowserNative = false,
}) => {
  const translate = useTranslate();

  const handleSearch = () => {
    setFilterValue(value);
  };

  const handleClear = () => {
    setValue('');
    setFilterValue('');
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
        marginBottom: 1,
      }}
    >
      <Box sx={{ minWidth: 80, fontSize: 14, fontWeight: 500 }}>{label}:</Box>

      {filterValue ? (
        <Box
          sx={{
            backgroundColor: '#e3f2fd',
            borderRadius: 1,
            fontSize: 14,
            color: '#1976d2',
            border: '1px solid #bbdefb',
          }}
        >
          {filterValue}
        </Box>
      ) : useBrowserNative ? (
        <input
          type={type}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyPress}
          placeholder={placeholder}
          disabled={disabled}
          style={{
            flex: 1,
            minWidth: 280,
            maxWidth: 480,
            padding: '8px 12px',
            fontSize: 14,
            border: '1px solid #c4c4c4',
            borderRadius: 4,
            outline: 'none',
          }}
        />
      ) : (
        <TextField
          type={type}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          size="small"
          disabled={disabled}
          sx={{ flex: 1, minWidth: 280, maxWidth: 480 }}
        />
      )}

      <Button
        variant={useBrowserNative ? 'outlined' : 'contained'}
        size="small"
        onClick={handleSearch}
        disabled={disabled || !value.trim()}
        sx={{ minWidth: useBrowserNative ? 80 : 0 }}
      >
        {translate('ra.action.search', { _: 'Search' })}
      </Button>

      <Button
        variant="outlined"
        size="small"
        onClick={handleClear}
        disabled={disabled}
        sx={{ minWidth: 80 }}
      >
        {translate('ra.action.clear_input_value', { _: 'Clear' })}
      </Button>
    </Box>
  );
};

export default FilterRow;
